"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          backgroundColor: "#f8fafc",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            maxWidth: "28rem",
            width: "100%",
            padding: "2rem",
            textAlign: "center",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <div
            style={{ fontSize: "2rem", marginBottom: "1rem", color: "#dc2626" }}
          >
            &#9888;&#65039;
          </div>
          <h1
            style={{
              fontSize: "1.125rem",
              fontWeight: 600,
              color: "#0f172a",
              marginBottom: "0.5rem",
            }}
          >
            Something went wrong
          </h1>
          <p style={{ color: "#64748b", marginBottom: "1.5rem" }}>
            An unexpected error occurred. Please try again or return to the home
            page.
          </p>
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              justifyContent: "center",
            }}
          >
            <button
              onClick={() => reset()}
              style={{
                padding: "0.5rem 1rem",
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "#ffffff",
                backgroundColor: "#1e40af",
                border: "none",
                borderRadius: "0.375rem",
                cursor: "pointer",
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => (window.location.href = "/")}
              style={{
                padding: "0.5rem 1rem",
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "#1e40af",
                backgroundColor: "transparent",
                border: "1px solid #cbd5e1",
                borderRadius: "0.375rem",
                cursor: "pointer",
              }}
            >
              Go Home
            </button>
          </div>
          <p
            style={{
              marginTop: "1.5rem",
              fontSize: "0.75rem",
              color: "#94a3b8",
            }}
          >
            Contractor Co-Pilot
          </p>
        </div>
      </body>
    </html>
  );
}
